import React from 'react'
import { /*Segment, Container, Divider,*/ Grid/*, Image, List*/, Menu } from 'semantic-ui-react'
// import { Link } from 'react-router-dom'

export default () => (
    // <div>
    //     <Segment
    //         style={{ margin: '5em 0em 0em', padding: '5em 0em',backgroundColor:"#333", color:'#ccc' }}
    //         vertical
    //         >
    //         <Container textAlign='center'>
    //             <Grid columns={2} divided stackable inverted>
    //                 <Grid.Row>
    //                     <Grid.Column>
    //                         <Image
    //                             centered
    //                             size='small'
    //                             src='/assets/images/logo.png'
    //                         />
    //                         <p>
    //                             <a href="http://www.roomminister.com/">www.roomminister.com</a>
    //                         </p>

    //                         <p>
    //                             MEETING ROOM BOOKING SYSTEM
    //                         </p>

    //                         <p>an intelligent software that help you to easily coordinate the people, spaces, and things in your office.</p>
    //                     </Grid.Column>                                 
    //                     <Grid.Column>
    //                         <Image
    //                             centered
    //                            
    //                             src='/assets/images/logo-bainisys.png'
    //                         />
    //                         <p>
    //                             <a href="http://www.bainisys.com">www.bainisys.com</a>
    //                         </p>
    //                         <p>YOUR BUSINESS PARTNER</p>
    //                         <p>The consulting firm in Thailand that provides a variety of IT service.</p>
    //                     </Grid.Column>
    //                 </Grid.Row>
    //             </Grid>
    //             <Divider inverted section />
    //             {/* <Image
    //                 centered
    //                 size='small'
    //                 src='/assets/images/logo.png'
    //             /> */}
    //             {/* <List horizontal inverted divided link>
    //                 <List.Item as='a' href='#'>Site Map</List.Item>
    //                 <List.Item as='a' href='#'>Contact Us</List.Item>
    //                 <List.Item as='a' href='#'>Terms and Conditions</List.Item>
    //                 <List.Item as='a' href='#'>Privacy Policy</List.Item>
    //             </List> */}
    //         </Container>
    //     </Segment>
    // </div>
    <Menu secondary fixed="bottom" style={{height: '55px'}}>
        <Grid style={{ margin: '1em 0em 0em', padding: '1em 0em',backgroundColor:"#333", color:'#ccc', width: '100%',  textAlign: 'center' }}>
            <Grid.Row>
                <Grid.Column width={8} >
                    {/* <Image
                        centered
                        size='small'
                        src='/assets/images/logo.png'
                    />
                    <p>
                        <a href="http://www.roomminister.com/" style={{color:'#ccc'}}>www.roomminister.com</a>
                    </p> */}

                    {/* <p>
                        MEETING ROOM BOOKING SYSTEM
                            </p> */}
                </Grid.Column>
                <Grid.Column width={8}>
                    {/* <Image
                        centered
                       
                        src='/assets/images/logo-bainisys.png'
                    />
                    <p>
                        <a href="http://www.bainisys.com" style={{color:'#ccc'}}>www.bainisys.com</a>
                    </p> */}
                    {/* <p>YOUR BUSINESS PARTNER</p>
                    <p>The consulting firm in Thailand that provides a variety of IT service.</p> */}
                </Grid.Column>
            </Grid.Row>
        </Grid>
    </Menu>
)


// WEBPACK FOOTER //
// ./src/features/ui/components/Footer.js